import React from 'react'
import PropTypes from 'prop-types'
import './banner11.css'

const Banner11 = ({ heading1, content1 }) => (
  <header className="banner11-container1 thq-section-padding">
    <div className="banner11-thq-max-width-elm thq-section-max-width">
      <h1 className="banner11-thq-title-elm thq-heading-2">{heading1 || 'NuggetCraft SMP'}</h1>
      <p className="banner11-text1 thq-body-large">{content1 || 'Server information and guidelines.'}</p>
    </div>
  </header>
)

Banner11.propTypes = {
  heading1: PropTypes.node,
  content1: PropTypes.node,
}

export default Banner11
